/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRejectCategory = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 22H2v-6h6zm-4-2h2v-2H4zm16.4 1.8L19 20.4l-1.4 1.4-1.4-1.4 1.4-1.4-1.4-1.4 1.4-1.4 1.4 1.4 1.4-1.4 1.4 1.4-1.4 1.4 1.4 1.4zM14 20h-4v-2h4zm-6-5H2V9h6zm-4-2h2v-2H4zm18 0H10v-2h12zM8 8H2V2h6zM4 6h2V4H4zm18 0H10V4h12z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgRejectCategory as RejectCategory };
